import auth from '@/middleware/modules/auth'

const EmbedsIndex = () => import(/* webpackChunkName: "_v-embeds" */ '@/views/embeds/EmbedsIndex.vue')
const EmbedEdit = () => import(/* webpackChunkName: "_v-embeds" */ '@/views/embeds/EmbedEdit.vue')

export default [
  {
    path: 'embeds',
    name: 'embeds',
    component: EmbedsIndex,
    props: (route) => ({ querySearch: route.query.search }),
    meta: {
      layout: 'app-layout',
      middleware: [auth],
    },
  },
  {
    path: 'embed/new',
    name: 'embed-new',
    component: EmbedEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['embeds'],
    },
  },
  {
    path: 'embed/:id/edit',
    name: 'embed-edit',
    component: EmbedEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['embeds'],
    },
  },
]
